import { Api } from './index';

export const fetchCharityList = () => Api.get('/products/charities');

export const postCharityDonation = (data) =>
  Api.post('/orders/charities', data);

export const fetchCharityReceipt = (id) => Api.get(`/orders/charities/${id}`);
